export enum CtepBrandID{
	VISA_ELECTRON = "1002",
	V_PAY = "1003",
	MAESTRO = "1009",
	PETROL_CARDS_NAT = "1011",
	PETROL_CARDS_INT = "1012",
	BANCONTACT = "1013",
	CARTES_BANCAIRES = "1020",
	PAYCONIQ = "1030",
	GOODPAY = "1040",
	VISA_DEBIT_ONLY_NL = "1052",
	DEBIT_MASTERCARD_ONLY_NL = "1053",
	VISA = "2002",
	MASTERCARD = "2003",
	AMEX = "2004",
	DINERS_DISCOVER = "2005",
	JCB = "2007",
	UNIONPAY = "2008",
	MONIZZE = "2009",
	UP_SLOVENSKO = "2019",
	SODEXO_CARD = "3003",
	EDENRED = "3004",
	CCV_CARD = "3013",
	WORLDLINE_WL = "3021",
	EQUENS_WL = "3100",
	GIFTCARD = "3300",
	KADOZ = "3400",
	RES = "3401",
	ALIPAY_QR = "9001",
	WECHAT_PAY_QR = "9002",
	PAYCONIQ_QR = "9003",
}


const CtepBrandNames = {
	"1002": "Visa Electron",
	"1003": "V PAY",
	"1009": "Maestro",
	"1011": "Petrol Cards Nat",
	"1012": "Petrol Cards Int",
	"1013": "Bancontact",
	"1020": "Cartes Bancaires",
	"1030": "Payconiq",
	"1040": "GoodPay",
	"1052": "Visa Debit (Only NL)",
	"1053": "Debit Mastercard (Only NL)",
	"2002": "Visa",
	"2003": "MasterCard",
	"2004": "AMEX",
	"2005": "Diners/Discover",
	"2007": "JCB",
	"2008": "UnionPay",
	"2009": "Monizze",
	"2019": "UP SLOVENSKO",
	"3003": "Sodexo Card",
	"3004": "Edenred",
	"3013": "CCV Card",
	"3021": "Worldline WL",
	"3100": "Equens WL",
	"3300": "Giftcard",
	"3400": "KADOZ",
	"3401": "RES",
	"9001": "Alipay QR",
	"9002": "WeChat Pay QR",
	"9003": "Payconiq QR",
};

export function getBrandName(brandId:CtepBrandID):string {
	return CtepBrandNames[`${brandId}`] || "ERROR";
}